var React = require('react');

function Wait (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M1.412 12.012c0 5.854 4.746 10.6 10.6 10.6s10.6-4.746 10.6-10.6-4.746-10.6-10.6-10.6-10.6 4.746-10.6 10.6M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12m-12.378-.317V4.007h1.5v8.54l-5.564 3.232-.754-1.297z"}));
}

Wait.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Wait;

Wait.default = Wait;
